export default __webpack_public_path__ + "4777f342ac864ffd7da22a730a32ffb7.png";